/**
 * Session Expired Modal
 *
 * Shown when 30-minute idle timeout triggers.
 * "Sign In Again" button pre-fills username.
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

function SessionExpiredModal() {
  const navigate = useNavigate();
  const { signInAgain, appState } = useAuth();

  if (appState !== 'session_expired') return null;

  const handleSignIn = () => {
    const email = signInAgain();
    navigate('/login', { replace: true, state: { reason: 'expired', email } });
  };

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 9999,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'rgba(0,0,0,0.5)', backdropFilter: 'blur(4px)'
    }}>
      <div style={{
        background: 'white', borderRadius: '16px', padding: '32px',
        maxWidth: '400px', width: '90%', textAlign: 'center',
        boxShadow: '0 20px 60px rgba(0,0,0,0.2)',
        animation: 'fadeSlideIn 0.2s ease-out both'
      }}>
        {/* Clock icon */}
        <div style={{
          width: '56px', height: '56px', borderRadius: '50%',
          background: '#fef3c7', margin: '0 auto 16px',
          display: 'flex', alignItems: 'center', justifyContent: 'center'
        }}>
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#d97706" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10" />
            <polyline points="12 6 12 12 16 14" />
          </svg>
        </div>

        <h3 style={{ fontSize: '18px', fontWeight: 700, color: '#111827', margin: '0 0 8px' }}>
          Session Expired
        </h3>
        <p style={{ fontSize: '14px', color: '#6b7280', margin: '0 0 24px', lineHeight: 1.5 }}>
          Your session has expired for security. Please sign in again.
        </p>

        <button
          onClick={handleSignIn}
          style={{
            width: '100%', padding: '14px', border: 'none', borderRadius: '10px',
            background: 'linear-gradient(135deg, #2563eb, #1d4ed8)', color: 'white',
            fontSize: '16px', fontWeight: 600, cursor: 'pointer',
            boxShadow: '0 4px 14px rgba(37,99,235,0.4)'
          }}
        >
          Sign In Again
        </button>
      </div>

      <style>{`
        @keyframes fadeSlideIn {
          from { opacity: 0; transform: translateY(16px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
}

export default SessionExpiredModal;
